import { StoreAction, XmAction } from 'store/actions';
import { NowNotificationBannerCollection } from './models/collection';

export function nowNotificationBannerCollectionReducer(state: NowNotificationBannerCollection, action: XmAction<NowNotificationBannerCollection>): NowNotificationBannerCollection {
    switch (action.type) {
        case StoreAction.GET_NOW_NOTIFICATION_BANNER_COLLECTION:
            return action.payload;
        default:
            return state;
    }
}